import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { SessionDataService } from '../shared/services/session-data.service';
import { WebNGRedirectExtras } from '../shared/types/WebNGRedirectExtras';
import { VueLoadingService } from '@vue/vueframework';
import { Client } from '../shared/types/Client';

@Component({
  selector: 'app-webng-redirect-form',
  standalone: false,
  styleUrls: [ './webng-redirect-form.component.css' ],
  templateUrl: './webng-redirect-form.component.html'
})
export class WebngRedirectFormComponent implements OnInit {
  /**
   * Event Emitter that needs to be passed in from the parent so the form knows when to be submitted.
   * The data that the emitter emits should be a WebNGRedirectExtras object.
   */
  @Input() public submitEmitter: EventEmitter<WebNGRedirectExtras>;

  @ViewChild('redirectForm', { static: true }) public redirectForm: ElementRef;
  public client: Client;
  public clientCode = '';
  public localeTag = '';
  public url = '';
  public redirectExtras: WebNGRedirectExtras;
  private readonly noClientUrl = 'https://www.pearsonvue.com/us/en/test-takers.html';

  public constructor(private sessionDataService: SessionDataService,
    private changeDetectorRef: ChangeDetectorRef,
    private vueLoadingService: VueLoadingService) { }

  public ngOnInit(): void {
    if (this.sessionDataService.getClient()) {
      this.client = this.sessionDataService.getClient();
      this.clientCode = this.client.clientCode;
    }

    this.localeTag = this.sessionDataService.getLocale();
    this.url = this.generateURL();

    this.submitEmitter.subscribe((extras: WebNGRedirectExtras) => {
      this.redirectExtras = extras;
      this.vueLoadingService.changeCurrentRestState(true);
      this.doRedirect();
    });
  }

  /**
   * Builds the URL to the redirect form in WebNG application.
   * If there is no client code set it will default to send the candidate to
   * the default 'find a program' page on the pearson vue website.
   * @returns The client WebNG url or default Pearson VUE website
   */
  public generateURL(): string {
    if (!this.client || !this.client.signInRedirectURL) {
      return this.noClientUrl;
    }

    return this.client.signInRedirectURL;
  }

  /**
   * Applies changes to the DOM due to updated redirect extras and then submits the form.
   */
  public doRedirect(): void {
    this.changeDetectorRef.detectChanges();
    this.redirectForm.nativeElement.submit();
  }

  public typeof(thing): string {
    return typeof thing;
  }

  public stringify(thing): string {
    return JSON.stringify(thing);
  }
}
